var map = {
	"./frontend/AndroidGuide.vue": 3110,
	"./frontend/BetslipHistory.vue": 8027,
	"./frontend/BodyFB.vue": 8425,
	"./frontend/ContactUs.vue": 5077,
	"./frontend/DataTable.vue": 818,
	"./frontend/Deposit.vue": 5970,
	"./frontend/History.vue": 5482,
	"./frontend/Home.vue": 8246,
	"./frontend/IOSGuide.vue": 9210,
	"./frontend/Index.vue": 4128,
	"./frontend/Live.vue": 2260,
	"./frontend/MainMenu.vue": 7061,
	"./frontend/ManualDeposit.vue": 7644,
	"./frontend/ManualWithdraw.vue": 2256,
	"./frontend/MaungFB.vue": 2466,
	"./frontend/Setting.vue": 1428,
	"./frontend/VideoLink.vue": 1784,
	"./frontend/Withdraw.vue": 5148,
	"./frontend/auth/Login.vue": 4822,
	"./frontend/auth/Rule.vue": 9786,
	"./frontend/components/AccountSelect.vue": 6311,
	"./frontend/components/DataTable.vue": 3639,
	"./frontend/components/FBPreviewVoucher.vue": 3999,
	"./frontend/components/FBVoucher.vue": 3164,
	"./frontend/components/FootballTeamCard.vue": 3773,
	"./frontend/components/PreviewVoucher.vue": 8026,
	"./frontend/components/SideNav.vue": 1604,
	"./frontend/components/Table.vue": 4100,
	"./frontend/normal-user/Index.vue": 5531
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7057;